module.exports = __webpack_public_path__ + "img/folder.3ff8fa30.webp";